import {createApp} from 'vue'
import './assets/index.css'
import App from './App.vue'

import {createWebHistory, createRouter} from 'vue-router'

import Dashboard from "@/pages/Dashboard.vue";
import CreateOrganisation from "@/pages/CreateOrganisation.vue";
import OrganisationDashboard from "@/pages/OrganisationDashboard.vue";
import AppCreate from "@/pages/AppCreate.vue";
import OrganisationSettings from "@/pages/OrganisationSettings.vue";
import AppDashboard from "@/pages/AppDashboard.vue";
import PanelCreate from "@/pages/PanelCreate.vue";
import PanelDesigner from "@/pages/PanelDesigner.vue";
import AppSettings from "@/pages/AppSettings.vue";
import AppAnalytics from "@/pages/AppAnalytics.vue";
import PanelHistory from "@/pages/PanelHistory.vue";
import PanelSettings from "@/pages/PanelSettings.vue";
import Settings from "@/pages/Settings.vue";
import Billing from "@/pages/Billing.vue";

const routes = [
    {path: '/', component: Dashboard},
    {path: '/create', component: CreateOrganisation},
    {path: '/:organisationId', name: 'OrganisationDashboard', component: OrganisationDashboard},
    {path: '/:organisationId/settings', component: OrganisationSettings},

    // APP
    {path: '/:organisationId/create', component: AppCreate},
    {path: '/:organisationId/app/:appId', name: 'AppDashboard', component: AppDashboard},
    {path: '/:organisationId/app/:appId/settings', component: AppSettings},
    {path: '/:organisationId/app/:appId/analytics', name: 'AppAnalytics', component: AppAnalytics},

    // PANELS
    {path: '/:organisationId/app/:appId/create', component: PanelCreate},
    {path: '/:organisationId/app/:appId/panel/:panelId', component: PanelDesigner},
    {path: '/:organisationId/app/:appId/panel/:panelId/settings', component: PanelSettings},
    {path: '/:organisationId/app/:appId/panel/:panelId/history', component: PanelHistory},

    // Settings and Billing
    {path: '/settings', component: Settings},
    {path: '/billing', component: Billing}
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

createApp(App)
    .use(router)
    .mount('#app')
